export var STEP_PROGRESS_STEP_CLASSNAME = 'eds-step-progress-step';
export var MOBILE_STEPPER_LABEL_CLASSNAME = 'eds-mobile-stepper-label';
export var STEP_LABEL_CLASSNAME = 'eds-step-label';
export var STEP_LABEL_ERROR_CLASSNAME = 'eds-step-label-error';
export var STEP_LABEL_HAS_ERROR_CLASSNAME = 'eds-step-label-has-error';
export var ACTIVE_STEP_SCREEN_READER_TEXT = 'eds-active-step-screen-reader-text';